import {WebCallService} from "@/utilities/services/WebCallService";
import {PathHelper} from "@/utilities/helpers/PathHelper";
import {ErrorLocationType, HttpType} from "@/utilities/enums/Enums";
import ErrorHandler from "@/utilities/helpers/ErrorHandler";
import User from "@/models/entities/User";
import GeneralRequest from "@/models/api/GeneralRequest";
import GeneralResponse from "@/models/api/GeneralResponse";

// noinspection DuplicatedCode
export default class UserService {
    private webCaller: WebCallService;
    private uriHelper: PathHelper;

    constructor(){
        this.webCaller = new WebCallService();
        this.uriHelper = new PathHelper();
    }

    public async getByMail(mail:string, errorLocationType:ErrorLocationType):Promise<User|null>{
        const uri = this.uriHelper.user.getByMailPath();
        const requestBody = new GeneralRequest(new User({email:mail}));

        const resp = await this.webCaller.httpSend<GeneralResponse>(HttpType.post, uri, requestBody);
        if (resp === null || resp === undefined || !resp.success) {
            await ErrorHandler.handleResponse(resp, errorLocationType);
            return null;
        }

        return resp.data as User;
    }

    public async updateUserConfig(user:User, errorLocationType:ErrorLocationType):Promise<boolean|null>{
        const uri = this.uriHelper.user.getUpdateUserConfigPath();
        const requestBody = new GeneralRequest(user);

        const resp = await this.webCaller.httpSend<GeneralResponse>(HttpType.post, uri, requestBody);
        if (resp === null || resp === undefined || !resp.success) {
            await ErrorHandler.handleResponse(resp, errorLocationType);
            return null;
        }

        return resp.success;
    }
}